import { Logo } from '@/components/ui/Logo';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const productLinks = [
  { to: '/#features', label: 'Features' },
  { to: '/#how-it-works', label: 'How it works' },
  { to: '/use-cases', label: 'Use cases' },
  { to: '/pricing', label: 'Pricing' },
];

const companyLinks = [
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
  { to: '#', label: 'Careers' },
];

export const LandingFooter = () => {
  return (
    <footer className="bg-midnight-green text-ivory">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5 space-y-5">
            <Link to="/" className="inline-flex items-center transition-transform duration-200 hover:scale-[1.02]">
              <Logo variant="horizontal" size="md" className="brightness-0 invert" />
            </Link>
            <p className="font-display text-xl text-ivory/85 leading-snug max-w-sm text-balance">
              Pro-level kitchen command for outdoor culinary teams.
            </p>
            <div className="flex gap-5 pt-2">
              {[
                { Icon: Facebook, label: 'Facebook' },
                { Icon: Twitter, label: 'Twitter' },
                { Icon: Instagram, label: 'Instagram' },
                { Icon: Linkedin, label: 'LinkedIn' },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  aria-label={label}
                  className="text-ivory/55 hover:text-copper transition-colors duration-200"
                >
                  <Icon className="h-4 w-4" strokeWidth={1.6} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-2">
            <h3 className="text-[11px] uppercase tracking-[0.18em] text-copper font-medium mb-5">Product</h3>
            <ul className="space-y-3">
              {productLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="story-link font-inter text-sm text-ivory/75 hover:text-ivory">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-[11px] uppercase tracking-[0.18em] text-copper font-medium mb-5">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="story-link font-inter text-sm text-ivory/75 hover:text-ivory">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div className="md:col-span-3">
            <h3 className="text-[11px] uppercase tracking-[0.18em] text-copper font-medium mb-5">Stay in the loop</h3>
            <p className="font-inter text-sm text-ivory/70 leading-relaxed mb-4">
              Camp kitchen best practices, once a month.
            </p>
            <form className="flex items-center border-b border-ivory/25 focus-within:border-copper transition-colors">
              <input
                type="email"
                placeholder="you@camp.org"
                className="flex-1 bg-transparent py-2.5 text-sm text-ivory placeholder:text-ivory/40 focus:outline-none"
              />
              <button
                type="submit"
                className="font-inter text-xs uppercase tracking-[0.18em] font-medium text-copper hover:text-ivory transition-colors px-2"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-ivory/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-inter text-xs text-ivory/50">© 2025 CampChef Pro. All rights reserved.</p>
          <div className="flex gap-6 text-xs">
            {[
              { to: '/privacy', label: 'Privacy' },
              { to: '/terms', label: 'Terms' },
              { to: '/security', label: 'Security' },
            ].map((l) => (
              <Link
                key={l.label}
                to={l.to}
                className="font-inter text-ivory/55 hover:text-copper transition-colors story-link"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
